import { useCallback } from 'react';
import { useTranslation, useUsersOptions } from '@hooks';

// Assignee choices for a conversation: an explicit "Unassigned" entry plus the
// team's users, shared by the header quick control and the details drawer.
export const useAssigneeOptions = () => {
    const { t } = useTranslation();
    const { getUsersOptionsByTeamId } = useUsersOptions();

    return useCallback(
        teamId => [{ value: null, label: t('common.unassigned') }, ...getUsersOptionsByTeamId(teamId)],
        [getUsersOptionsByTeamId, t],
    );
};
